module.exports = __webpack_public_path__ + "img/Group122.26070368.png";